// يحسب قائمة الحقول الناقصة قبل السماح بحفظ أمر الشراء.
const num = (v) => { const n = parseFloat(v); return isFinite(n) ? n : 0; };

export const validationHints = (t, head, lines, needsSupplier) => {
  const missing = [];
  if (needsSupplier && !head.supplier_id) missing.push(t("purchases.validate.supplier"));
  if (!head.delivery_branch_id) missing.push(t("purchases.validate.branch"));
  if (!head.delivery_warehouse_id) missing.push(t("purchases.validate.warehouse"));
  const okLine = lines.some((l) => l.master_item_id && num(l.quantity) > 0 && num(l.unit_price) > 0);
  if (!okLine) missing.push(t("purchases.validate.line"));
  return { valid: missing.length === 0, missing };
};
